import { render } from "./contactForm.vue?vue&type=template&id=2713e9cc&ts=true"
import script from "./contactForm.vue?vue&type=script&lang=ts"
export * from "./contactForm.vue?vue&type=script&lang=ts"

import "./contactForm.vue?vue&type=style&index=0&id=2713e9cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__